import Logo from "components/common/Logo";
import Printable from "components/modules/reporting/A4";
import React, { useRef } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import logo from "../../../../../../assets/img/logos/logoNew.png";
import { formatDate } from "utils/dateFormatter";

export default function VoucherPrint() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const printRef = useRef();

  // console.log(state);

  const triggerPrint = () => {
    printRef.current?.handlePrint?.();
  };

  const totalDebit = state?.entries?.reduce(
    (sum, entry) => sum + (entry.debit || 0),
    0
  );
  const totalCredit = state?.entries?.reduce(
    (sum, entry) => sum + (entry.credit || 0),
    0
  );

  const formatAmount = (amount) =>
    amount?.toLocaleString(undefined, { minimumFractionDigits: 2 });

  return (
    <>
      <Card>
        <Card.Header className="border-bottom">
          <Row className="flex-between-center">
            <Col md>
              <div className="d-flex align-items-center">
                <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
                  Accounts | Vouchers | Print
                </h5>
              </div>
            </Col>
            <Col xs="auto">
              <Button
                variant="link"
                className="text-secondary fw-medium p-0 me-3"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
              <Button variant="primary" onClick={triggerPrint}>
                Print
              </Button>
            </Col>
          </Row>
        </Card.Header>

        <Printable ref={printRef} documentTitle="Journal Voucher">
          <div style={{ padding: 40, fontSize: "14px" }}>
            {/* Header */}
            <div className="d-flex justify-content-between">
              <div>
                <div style={{ textAlign: "center", color: "black" }}>
                  <img
                    height={80}
                    width={80}
                    src={logo}
                    alt="Logo"
                    style={{ marginBottom: "20px" }}
                  />
                </div>
                <h4 style={{ textAlign: "center", color: "black" }}>
                  {state.type} Voucher
                </h4>
              </div>
              <div></div>
            </div>

            {/* Reference and Company */}
            <div className="d-flex justify-content-between my-4">
              <div>
                <strong>Company Name:</strong> ABC Corporation
                <br />
                <strong>Address:</strong> 123 Main St, City, Country
              </div>
              <div className="text-end">
                <div>
                  <strong>Reference #:</strong> {state.number}
                </div>
                <div>
                  <strong>Printed:</strong> {new Date().toLocaleDateString()}
                </div>
              </div>
            </div>

            {/* Voucher Table */}
            <div style={{ marginTop: 30 }}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>SR NO.</th>
                    <th style={styles.th}>A/C NAME</th>
                    <th style={styles.th}>SUB LEDGER</th>
                    <th style={styles.th}>DESCRIPTION</th>
                    <th style={styles.th}>DEBIT</th>
                    <th style={styles.th}>CREDIT</th>
                  </tr>
                </thead>
                <tbody>
                  {state.entries?.map((entry, index) => (
                    <tr key={index}>
                      <td style={styles.td}>{index + 1}</td>
                      <td style={styles.td}>{entry.accountTitle}</td>
                      <td style={styles.td}>{entry.subLedgerName}</td>
                      <td style={styles.td}>{entry.description}</td>
                      <td style={styles.tdP}>
                        {entry.debit ? formatAmount(entry.debit) : "-"}
                      </td>
                      <td style={styles.tdP}>
                        {entry.credit ? formatAmount(entry.credit) : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan={4} style={styles.tdTotal}>
                      <strong>TOTAL</strong>
                    </td>
                    <td style={styles.tdTotalP}>
                      <strong>{formatAmount(totalDebit)}</strong>
                    </td>
                    <td style={styles.tdTotalP}>
                      <strong>{formatAmount(totalCredit)}</strong>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            {/* Approval Signature */}
            <div
              style={{
                marginTop: 100,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <div style={{ width: 300, textAlign: "center" }}>
                <div
                  style={{ borderBottom: "1px solid #000", marginBottom: 9 }}
                ></div>
                <div>Authorized Signature</div>
              </div>
            </div>
          </div>
        </Printable>
      </Card>
    </>
  );
}

const border = "1px solid #000";
const basePadding = "8px 10px";
const baseTextAlignLeft = "left";
const baseTextAlignRight = "right";

const bg = {
  lightGray: "#f8f8f8",
  gray: "#e6e6e6",
  darkGray: "#A9A9A9",
};

const styles = {
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: 20,
  },
  th: {
    border,
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    backgroundColor: bg.darkGray,
    fontWeight: "bold",
  },
  td: {
    border,
    // borderRight: "none",
    padding: basePadding,
    textAlign: baseTextAlignLeft,
  },
  tdP: {
    border,
    // borderLeft: "none",
    padding: basePadding,
    textAlign: baseTextAlignRight,
  },
  tdTotal: {
    border,
    // borderRight: "none",
    padding: basePadding,
    textAlign: baseTextAlignLeft,
    fontWeight: "bold",
    backgroundColor: bg.darkGray,
  },
  tdTotalP: {
    border,
    // borderLeft: "none",
    padding: basePadding,
    textAlign: baseTextAlignRight,
    fontWeight: "bold",
    backgroundColor: bg.darkGray,
  },
};
